import React, { FunctionComponent } from 'react';
import type { Tv } from '../../../types/tvs';

type Props = {
  relatedTvs: Tv[];
};

export const Presentation: FunctionComponent<Props> = ({
  relatedTvs,
}) => {
  if (relatedTvs.length === 0) return null;

  return (
    <div className="tv-content-bottom">
      <h2 className="tv-content-bottom-title">関連動画</h2>
      <ul className="tv-content-bottom-list gtm-movie-view-count" data-event-name='movie on screen' data-category="tvcontent" data-value="related_movie">
        {relatedTvs.map((tv) => (
          <a
            href={`/tvs/${tv.id}`}
            className="tv-content-bottom-list-link"
            key={tv.id}
            data-event="click"
            data-category="tvcontent"
            data-value="related_movie"
            data-movieid={tv.id}
            data-companyid={tv.companyId}
          >
            <li className="tv-content-bottom-list-item">
              <div
                style={{
                  background: `url(${tv.image}) no-repeat center center`,
                  backgroundSize: 'cover',
                  width: '100%',
                  height: 0,
                  paddingTop: '55.25%',
                }}
              />
              <h3 className="tv-content-bottom-list-title">{tv.title}</h3>
              <p className="tv-content-bottom-list-company">{tv.companyName}</p>
              <div className="tv-content-bottom-list-info">
                <p className="tv-content-bottom-list-info-date">{tv.updatedAt}</p>
              </div>
            </li>
          </a>
        ))}
      </ul>
    </div>
  );
};
